import {
  keepPreviousData,
  useMutation,
  useQuery,
  useQueryClient,
} from "@tanstack/react-query";
import { UsersService } from "../services/users.service";
import { DEFAULT_LIMIT } from "../../../shared/dto/pagination.dto";

export const useGetUsersHook = (page: number, limit: number = DEFAULT_LIMIT) => {
  return useQuery({
    queryKey: ["users", page, limit],
    queryFn: () => UsersService.getUsers(page, limit),
    placeholderData: keepPreviousData,
  });
};

export const useGetUserReservationsHook = (
  userId: string,
  event: string,
  page: number,
  limit: number = DEFAULT_LIMIT
) => {
  return useQuery({
    queryKey: ["users", "reservations", userId, event, page, limit],
    queryFn: () =>
      UsersService.getUserReservations(userId, event, page, limit),
    enabled: !!userId && !!event,
    placeholderData: keepPreviousData,
  });
};

export const useSuspendUserHook = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (userId: string) => UsersService.suspendUser(userId),
    onSuccess: () =>
      queryClient.invalidateQueries({ queryKey: ["users"] }),
  });
};

export const useReactivateUserHook = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (userId: string) => UsersService.reactivateUser(userId),
    onSuccess: () =>
      queryClient.invalidateQueries({ queryKey: ["users"] }),
  });
};
